import { createListenerMiddleware } from "@reduxjs/toolkit";
import { addMiddleware } from "redux-dynamic-middlewares";
import routingStateSlice from "./slices";

const routingActions = routingStateSlice.actions;

const listenerMiddleware = createListenerMiddleware();

// This listener keeps the URL up to date on the window object.
listenerMiddleware.startListening({
  type: routingActions.updateUrl.type,
  effect: (action) => {
    const newUrl = action.payload;
    // This new URL is pushed into the window history state to be accessed through the browser's
    // back and forward buttons, however, those buttons won't trigger a page reload until the
    // the subscriber method in the backForwardHandler.js file is executed.
    window.history.pushState({}, "", newUrl);
  },
});

addMiddleware(listenerMiddleware.middleware);
